import { Icon } from '@iconify/react';

export default function PedidoInfoPanel({ pedido }) {
  if (!pedido) return null;

  const Field = ({ label, value, icon }) => (
    <div className="flex items-start space-x-2 text-sm text-gray-800">
      {icon && <Icon icon={icon} className="w-4 h-4 mt-0.5 text-gray-500" />}
      <span className="font-medium">{label}:</span>
      <span className="text-gray-700">{value || 'N/A'}</span>
    </div>
  );

  const Section = ({ title, children }) => (
    <div className="bg-white rounded-2xl shadow-sm p-3 space-y-2 border border-gray-100">
      <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{title}</h3>
      <div className="grid md:grid-cols-2 gap-x-6 gap-y-2">{children}</div>
    </div>
  );

  return (
    <div className="grid gap-4">
      <Section title="Pedido">
        <Field label="N° Pedido" value={pedido.numPedido} icon="mdi:clipboard-text-outline" />
        <Field label="Referencia Cliente" value={pedido.clienteReferencia} icon="mdi:account-box-outline" />
        <Field label="Clase de Documento" value={pedido.documentoClase} icon="mdi:file-document-outline" />
        <Field label="Motivo Pedido" value={pedido.pedidoMotivo} icon="mdi:comment-question-outline" />
      </Section>

      <Section title="Solicitante y Destinatario">
        <Field label="Rol Solicitante" value={pedido.rolSolicitante} icon="mdi:account-outline" />
        <Field label="N° Solicitante" value={pedido.numSolicitante} />
        <Field label="Rol Destinatario" value={pedido.rolDestinatario} />
        <Field label="N° Destinatario" value={pedido.numDestinatario} />
      </Section>

      <Section title="Información Comercial">
        <Field label="Org. Ventas" value={pedido.ventasOrganizacion} icon="mdi:office-building-outline" />
        <Field label="Canal Distribución" value={pedido.distribucionCanal} icon="mdi:truck-outline" />
        <Field label="Sector" value={pedido.sector} />
        <Field label="Cond. Expedición" value={pedido.expedicionCond} />
        <Field label="Condiciones de Pago" value={pedido.condicionPago} icon="mdi:cash-check" />
        <Field label="Vía de Pago" value={pedido.viaPago} />
      </Section>

      <Section title="Fechas Relevantes">
        <Field label="Entrega" value={pedido.fechaEntrega} icon="mdi:calendar-check-outline" />
        <Field label="Fecha Ref. Cliente" value={pedido.clienteFechaRef} />
        <Field label="Fecha Documento" value={pedido.documentoFecha} />
        <Field label="Fecha Precio" value={pedido.precioFecha} />
        <Field label="Fecha Mercancía Cliente" value={pedido.clienteFechaMercancia} />
        <Field label="Creado" value={pedido.createdAt ? new Date(pedido.createdAt).toLocaleDateString() : null} icon="mdi:calendar-clock" />
      </Section>

      <Section title="CFDI">
        <Field label="Uso CFDI" value={pedido.useCfdi} />
        <Field label="Texto CFDI" value={pedido.cfdiTexto} />
        <Field label="Lenguaje CFDI" value={pedido.cfdiLenguaje} />
        <Field label="Método de Pago" value={pedido.metodoPago} />
        <Field label="Texto Método Pago" value={pedido.metPagoTexto} />
        <Field label="Lenguaje Método Pago" value={pedido.metPagoLenguaje} />
      </Section>

      <Section title="Aplicación">
        <Field label="Aplicación" value={pedido.appName} icon="mdi:web" />
      </Section>
    </div>
  );
}
